<template>
  <span class="checkmark">
    <Icon id="checkmark" />
    <span>___</span>
  </span>
</template>

<script>
import { Icon } from '@/components/global'

export default {
  name: 'BannerCheckmark',
  components: { Icon },
}
</script>
